<template>
  <div>
    <v-select
      :items="yearsOptions"
      v-model="year"
      label="År"
      dense
      outlined
      clearable
      hide-details
    />
  </div>
</template>

<script>
export default {
  name: 'FilterYear',
  props: {
    article_year: { type: Number },
  },

  computed: {
    yearsOptions() {
      var max = new Date().getFullYear()
      var min = max - 20
      var years = []

      for (var i = max; i >= min; i--) {
        years.push(i)
      }
      return years
    },
    year: {
      get() {
        if (!this.article_year) return null
        return this.article_year.trim()
      },
      set(value) {
        this.$emit('change', { key: 'article_year', value })
      },
    },
  },
}
</script>

<style lang="less" scoped></style>
